import PatientSessionsComparison from '../components/Sessions/PatientSessionsComparison';

const SessionComparisonPage = () => {
  return <PatientSessionsComparison />;
};

export default SessionComparisonPage;